export default __webpack_public_path__ + "static/media/iconos-talks_y_workshops.4118d261.png";